module.exports = __webpack_public_path__ + "img/SAR.cba2fc99.svg";